module.exports = __webpack_public_path__ + "img/hx-rkgl-w.10178ad2.svg";